import { Back } from "../components/button/Back";
import { LoggedInLayout } from "../components/layouts/LoggedInLayout";
import { PageTitle } from "../components/text/PageTitle";

const SettingsPage = () => {
	return (
		<LoggedInLayout width="s">
			<PageTitle>Inställningar</PageTitle>
			<Back />
		</LoggedInLayout>
	);
};

export default SettingsPage;
